import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { BaseAdvancedFilters } from "./BaseAdvancedFilters";

export class MonthListAdvancedFilter extends BaseAdvancedFilters {
    protected override _constructor(): void {
        super._constructor();

        this.addItems([
            { value: 1, id: "January", lockey: "GUI-643669", valueType: "monthlist" }, //leden
            { value: 2, id: "February", lockey: "GUI-643670", valueType: "monthlist" }, //Únor
            { value: 3, id: "March", lockey: "GUI-643671", valueType: "monthlist" }, //Březen
            { value: 4, id: "April", lockey: "GUI-643672", valueType: "monthlist" }, //Duben
            { value: 5, id: "May", lockey: "GUI-643673", valueType: "monthlist" }, //Květen
            { value: 6, id: "June", lockey: "GUI-643674", valueType: "monthlist" }, //Červen
            { value: 7, id: "July", lockey: "GUI-643675", valueType: "monthlist" }, //Červenec
            { value: 8, id: "August", lockey: "GUI-643676", valueType: "monthlist" }, //Srpen
            { value: 9, id: "September", lockey: "GUI-643677", valueType: "monthlist" }, //Září
            { value: 10, id: "October", lockey: "GUI-643678", valueType: "monthlist" }, //Říjen
            { value: 11, id: "November", lockey: "GUI-643679", valueType: "monthlist" }, //Listopad
            { value: 12, id: "December", lockey: "GUI-643680", valueType: "monthlist" }, //Prosinec
        ]);
    }
}

registerCustomElement("tsc-MonthListAdvancedFilter", MonthListAdvancedFilter);
